var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('router-link',{attrs:{"tag":"li","to":{name: 'profile'}}},[_c('a',[_vm._v("Cuenta")])]),_c('router-link',{attrs:{"tag":"li","to":{name: 'account.status'}}},[_c('a',[_vm._v("Estado de Cuenta")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }